import { system } from './system-core.esm.js';
import { isNumber } from '../utils/assertion.esm.js';
import { memoizedGet } from '../utils/object.esm.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
var getWidth = function getWidth(n, scale) {
  return memoizedGet(scale, n, !isNumber(n) || n > 1 ? n : n * 100 + '%');
};
var config = {
  width: {
    property: 'width',
    scale: 'sizes',
    transform: getWidth
  },
  height: {
    property: 'height',
    scale: 'sizes'
  },
  minWidth: {
    property: 'minWidth',
    scale: 'sizes'
  },
  minHeight: {
    property: 'minHeight',
    scale: 'sizes'
  },
  maxWidth: {
    property: 'maxWidth',
    scale: 'sizes'
  },
  maxHeight: {
    property: 'maxHeight',
    scale: 'sizes'
  },
  size: {
    properties: ['width', 'height'],
    scale: 'sizes'
  },
  overflow: true,
  overflowX: true,
  overflowY: true,
  display: true,
  verticalAlign: true
};
var layout = system(config);

export default layout;
export { layout };
//# sourceMappingURL=layout.esm.js.map
